/* unplugin-vue-components disabled */import { render } from "./LeaveReview.vue?vue&type=template&id=3dc50d0f&scoped=true"
import script from "./LeaveReview.vue?vue&type=script&lang=js"
export * from "./LeaveReview.vue?vue&type=script&lang=js"

import "./LeaveReview.vue?vue&type=style&index=0&id=3dc50d0f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dc50d0f"]])

export default __exports__